import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const PipelinesRepoRunnersPageLoadable = Loadable<any, any>({
  loading: LoadingPage,
  loader: () => import('./runners'),
});

// eslint-disable-next-line import/no-default-export
export default PipelinesRepoRunnersPageLoadable;
